export const ADDONS_KALLAX = "addons-kallax";
